import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { fieldsPersonItemTitles } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useTranslation } from "react-i18next";

export default function FieldsBox() {
  const { t } = useTranslation();
  const personItemField: Array<stdObject> = useSelector(
    (state: RootState) => state.data.per,
  );
  const { type, searchValues, setSearchValues, section } =
    useStructureContext();
  const { setMsg, setWindowValues } = useMainContext();

  const openFieldsInfo = (data: stdObject) => {
    setMsg("fieldInfoModal");
    setWindowValues({ ...data });
  };

  useEffect(() => {
    if (searchValues[section.id].FIEPER.value === "") {
      const tempSearch = searchValues;
      tempSearch[section.id].FIEPER.value = "PRO";
      setSearchValues({ ...tempSearch });
    }
  }, []);

  return "FIEPER" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={fieldsPersonItemTitles}
        data={personItemField
          .filter(
            (e: stdObject) =>
              e.TIPPER === searchValues[section.id].FIEPER.value,
          )
          .sort((a: any, b: any) => b.ORDPER - a.ORDPER)
          .map((e: stdObject) => {
            return {
              ...e,
              FIEPER: e.CODPER === "STA" ? t("p.status") : t(`c.${e.CODPER}`),
            };
          })}
        onDoubleClick={openFieldsInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
